
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5359 12.732L5 3.80383L12.4641 8.73204L9.86602 10.232L11.866 13.6961L10.134 14.6961L8.13397 11.232L5.5359 12.732Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17 14C16.4105 14 16 14.4833 16 15H14C14 13.5167 15.1728 12 17 12C18.8081 12 20 13.4342 20 15C20 16.132 19.3017 17.0873 18.4587 17.5862C18.2836 17.6898 18.1478 17.8013 18.066 17.8998C18.0164 17.9597 18.003 17.9938 18 18.0047V19H16V18.0001C16 17.4229 16.2501 16.9563 16.5269 16.6227C16.8011 16.2923 17.1399 16.0427 17.4401 15.865C17.7959 15.6545 18 15.295 18 15C18 14.4414 17.6086 14 17 14Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16 20V22H18V20H16Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiMousehelpFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
